import React from 'react';
import clsx from 'clsx';

const variantClasses = {
  default:   'bg-neutral-100 text-neutral-700 ring-neutral-200',
  primary:   'bg-primary-100 text-primary-700 ring-primary-200',
  secondary: 'bg-secondary-100 text-secondary-700 ring-secondary-200',
  success:   'bg-success-100 text-success-700 ring-success-100',
  warning:   'bg-warning-100 text-warning-700 ring-warning-100',
  error:     'bg-error-100 text-error-700 ring-error-100',
  info:      'bg-primary-50 text-primary-600 ring-primary-100',
};

export default function Badge({ variant = 'default', className, children }) {
  return (
    <span
      className={clsx(
        'inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset',
        variantClasses[variant] ?? variantClasses.default,
        className
      )}
    >
      {children}
    </span>
  );
}
